import React from 'react'
import PropTypes from 'prop-types'

const Footer = props => {
    const trackArtPortfolioClick = () => {
        window.gtag('event', 'Click', {
            'event_category': 'Portfolio',
            'event_label': 'Art Portfolio Link',
            'value': 1
        });
    };

    return (
        <div className="w-full px-6 md:px-12 py-12" id="footer">
            <div className="max-w-4xl mx-auto text-center">
                {/* Art Portfolio CTA Card */}
                <div className="relative overflow-hidden rounded-2xl bg-gray-900 p-8 md:p-12 shadow-xl border border-gray-800 group">
                    {/* Background Pattern */}
                    <div className="absolute inset-0 opacity-20">
                        <div className="absolute -top-24 -right-24 w-48 h-48 bg-primary-500 rounded-full blur-3xl group-hover:bg-primary-400 transition-colors duration-500"></div>
                        <div className="absolute -bottom-24 -left-24 w-48 h-48 bg-purple-500 rounded-full blur-3xl group-hover:bg-purple-400 transition-colors duration-500"></div>
                    </div>

                    <div className="relative z-10">
                        <h3 className="text-2xl md:text-3xl font-bold text-white mb-4 font-display">
                            🎨 Check Out My <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary-400 to-purple-400">Art Portfolio!</span>
                        </h3>
                        <p className="text-lg text-gray-300 mb-8 max-w-2xl mx-auto leading-relaxed">
                            When I'm not coding, I love creating art.
                            Take a peek at my creative side!
                        </p>

                        <a
                            href="https://shubharts.vercel.app/"
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={trackArtPortfolioClick}
                            className="inline-flex items-center px-8 py-4 bg-primary-600 hover:bg-primary-700 text-white text-lg font-semibold rounded-xl transition-all duration-300 shadow-lg hover:shadow-primary-500/30 transform hover:-translate-y-1 group/btn"
                        >
                            <svg
                                className="w-6 h-6 mr-3 group-hover/btn:rotate-12 transition-transform duration-300"
                                viewBox="0 0 24 24"
                                fill="currentColor"
                            >
                                <path d="M12 3L1 9l4 2.18v6L12 21l7-3.82v-6l2-1.09v6.36c0 .73.39 1.41 1.02 1.77L12 21 1.98 16.23C1.39 15.87 1 15.19 1 14.46v-5.48L12 3zm6.82 6L12 12.72 5.18 9 12 5.28 18.82 9zM17 15.99l-5 2.73-5-2.73v-3.72L12 15l5-2.73v3.72z"></path>
                            </svg>
                            Visit My Art Portfolio
                        </a>
                    </div>
                </div>

                {/* Copyright */}
                <div className="mt-12 text-gray-500 text-sm">
                    <p>&copy; {new Date().getFullYear()} Subhransu Maharana. All rights reserved.</p>
                </div>
            </div>
        </div>
    )
}

Footer.propTypes = {}

export default Footer
